/**
 * @generated SignedSource<<635e24bdc7e08c82b4e9fb20ec8f2534>>
 * @relayHash 0227bda97ab2b17021ba925b5c8ca687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a8badb0416ae7200a2ad25042f225b1e0d4164e7f8778007b4e7f6d958a0ad7

import type { ConcreteRequest } from 'relay-runtime';
export type RolePickerWithPermissionQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type RolePickerWithPermissionQuery$data = {
  readonly jira: {
    readonly isProjectAdmin: boolean | null | undefined;
    readonly jiraProjectByKey: {
      readonly roles: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly description: string | null | undefined;
            readonly isAdmin: boolean | null | undefined;
            readonly isDefaultRole: boolean | null | undefined;
            readonly isRoleConfigurable: boolean | null | undefined;
            readonly name: string | null | undefined;
            readonly roleId: string;
            readonly translatedName: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RolePickerWithPermissionQuery = {
  response: RolePickerWithPermissionQuery$data;
  variables: RolePickerWithPermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "alias": "isProjectAdmin",
  "args": [
    (v1/*: any*/),
    {
      "kind": "Literal",
      "name": "permission",
      "value": "ADMINISTER_PROJECTS"
    },
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "hasProjectPermission"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "isDefaultRole"
},
v6 = {
  "kind": "ScalarField",
  "name": "roleId"
},
v7 = {
  "kind": "ScalarField",
  "name": "isAdmin"
},
v8 = {
  "kind": "ScalarField",
  "name": "isRoleConfigurable"
},
v9 = {
  "kind": "ScalarField",
  "name": "translatedName"
},
v10 = {
  "kind": "ScalarField",
  "name": "description"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RolePickerWithPermissionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraRoleConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraRoleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraRole",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RolePickerWithPermissionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraRoleConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraRoleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraRole",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v11/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6a8badb0416ae7200a2ad25042f225b1e0d4164e7f8778007b4e7f6d958a0ad7",
    "metadata": {},
    "name": "RolePickerWithPermissionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9457889e3af0d4fce8f5cba33dea8df6";

export default node;
